module.exports = __webpack_public_path__ + "46b748033ec614b6bee32363596029c5.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/1000_l_30.mp3
// module id = 458
// module chunks = 0